import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Transfer14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_227)'>
      <path
        d='M13.0608 4L9.53044 0.469666L8.46978 1.53033L10.1894 3.25H2.00011V4.75H10.1894L8.46978 6.46967L9.53044 7.53033L13.0608 4Z'
        fill='currentColor'
      />
      <path
        d='M3.81078 9.25L12.0001 9.25V10.75L3.81077 10.75L5.53044 12.4697L4.46978 13.5303L0.939453 10L4.46978 6.46967L5.53044 7.53033L3.81078 9.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_227'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Transfer14.displayName = 'Transfer14';
export default Transfer14;
